import L from 'leaflet';

L.Control.Save = L.Control.extend({
    options: {
        position: 'topleft',
    },

    onAdd: function (map) {
        const container = L.DomUtil.create('div', 'leaflet-control-save leaflet-bar leaflet-control');

        this.link = L.DomUtil.create('a', 'leaflet-bar-part', container);
        this.link.href = '#';

        L.DomEvent.disableClickPropagation(container);

        L.DomEvent.on(this.link, 'click', this._click, this);

        return container;
    },

    _click: function (e) {
        L.DomEvent.stopPropagation(e);
        L.DomEvent.preventDefault(e);
        this.options.onClick();
    },
});

L.control.save = (opts) => {
    return new L.Control.Save(opts);
};
